import { FC } from 'react';
import { Form } from 'semantic-ui-react';
import { EventField } from '../../api/events';
import { chunks } from '../../common';


interface FieldSettingsProps {
    fields: EventField[];
    visibleFields: Set<EventField>;
    onChange(fields: Set<EventField>): void;
}


const FieldSettings: FC<FieldSettingsProps> = ({ fields, visibleFields, onChange }) => {
    const fieldSwitch = (field: EventField) => {
        if (!visibleFields.delete(field)) {
            visibleFields.add(field);
        }

        onChange(new Set(visibleFields));
    };

    const groupSize = 4;

    return (
        <Form size='large'>
            {chunks(fields, groupSize).map((group, i) => (
                <Form.Group key={i} widths={groupSize}>
                    {group.map((field, j) => (
                        <Form.Checkbox
                            key={j}
                            inline
                            checked={visibleFields.has(field)}
                            label={field}
                            onChange={_ => fieldSwitch(field)}
                        />
                    ))}
                </Form.Group>
            ))}
        </Form>
    );
};


export default FieldSettings;
